<!--查询-->
<template>
    <div>
        <van-nav-bar :title="title" ></van-nav-bar>
        <!--        <van-divider content-position="left">文字</van-divider>-->
        <van-cell-group title="日期区间">
            <van-cell >
                <van-row type="flex" justify="center">
                    <van-col span="11"><van-field clickable readonly :value="formModel.startDate" placeholder="开始日期" @click="openDatePicker('start')"/></van-col>
                    <van-col span="2"><div style="margin-top:10px">至</div></van-col>
                    <van-col span="11"><van-field clickable readonly :value="formModel.endDate" placeholder="结束日期" @click="openDatePicker('end')"/></van-col>
                </van-row>
            </van-cell>
            <van-popup v-model="showDatePicker" position="bottom">
                <van-datetime-picker
                        v-model="pickDate"
                        type="date"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @cancel="showDatePicker = false"
                        @confirm="onDateConfirm"
                />
            </van-popup>
        </van-cell-group>

        <van-cell-group title="归属">
            <van-cell >
                <van-row >
                    <van-col span="6" v-for="item in belongs" :key="item.id">
                        <van-tag plain @click="selectTag(item.attrId,$event,formModel.belongs)" type="default">{{item.attrName}}</van-tag>
                    </van-col>

                </van-row>
            </van-cell>
        </van-cell-group>

        <van-cell-group title="分类">
            <van-cell >
                <van-row>
                    <van-col span="6" v-for="item in finTypes" :key="item.id">
                        <van-tag plain @click="selectTag(item.attrId,$event,formModel.finTypes)" type="default" >{{item.attrName}}</van-tag>
                    </van-col>

                </van-row>
            </van-cell>
        </van-cell-group>

        <van-cell-group title="付款人">
            <van-cell >
                <van-row>
                    <van-col span="6" v-for="item in payers" :key="item.id">
                        <van-tag plain @click="selectTag(item.attrId,$event,formModel.payers)" type="default" >{{item.attrName}}</van-tag>
                    </van-col>

                </van-row>
            </van-cell>
        </van-cell-group>
        <van-cell-group title="标签">
            <van-cell >
                <van-row>
                    <van-col span="6" v-for="item in tags" :key="item.id">
                        <van-tag plain @click="selectTag(item.attrId,$event,formModel.tags)" type="default" >{{item.attrName}}</van-tag>
                    </van-col>

                </van-row>
            </van-cell>
        </van-cell-group>

        <van-cell-group title="类型">
            <van-cell >
                <van-row>
                    <van-col span="6" v-for="item in items" :key="item.id" >
                        <van-tag plain @click="selectTag(item.attrId,$event,formModel.sorts)" type="default" >{{item.attrName}}</van-tag>
                    </van-col>

                </van-row>
            </van-cell>
        </van-cell-group>

        <van-cell-group title="明细">
            <van-cell >
                <van-tree-select
                        :items="items"
                        :active-id.sync="formModel.details"
                        :main-active-index.sync="activeIndex"
                />
            </van-cell>
        </van-cell-group>

        <van-cell-group>
            <van-row>
                <van-col span="6" offset="15">
                    <van-button style="margin-top: 10px;margin-bottom: 10px;" type="primary" size="small"
                                block round color="#fe7844" :loading="isLoading"
                                loading-text="查询中..."
                                @click="submitForm">查询</van-button>
                </van-col>

            </van-row>

        </van-cell-group>



        <!--        <van-index-bar :index-list="indexList">-->
        <!--            <van-index-anchor index="1">日期区间</van-index-anchor>-->


        <!--            <van-index-anchor index="2">标题2</van-index-anchor>-->
        <!--            <van-cell title="文本" />-->
        <!--            <van-cell title="文本" />-->
        <!--            <van-cell title="文本" />-->

        <!--        </van-index-bar>-->
    </div>
</template>

<script>
    import {formatDate,stringToDate} from '../../common/utils/dateUtil.js'
    import * as MyApi from '../../api/URLApiAddr.js'

    export default {
        name: "MultipleQuery",
        data(){
            return {
                title:'综合查询',
                indexList: [],
                formModel: {
                    startDate: '',
                    endDate: '',
                    sorts: [],
                    payers: [],
                    finTypes: [],
                    belongs: [],
                    details: [],
                    tags: [],
                    popupShow: false
                },
                showDatePicker: false,
                dateType:'start',
                pickDate:new Date(),
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(2025, 10, 1),
                activeIds: [],
                activeIndex: 0,
                belongs:[],
                finTypes: [],
                payers: [],
                items: [],
                tags:[],
                isLoading: false


            }
        },
        created:function() {
            this.initData()

        },
        methods : {
            initData(){
                this.$axios.get(MyApi.QRY_ATTR_ALL_LIST).then((resp) => {
                    if(resp.code == '200'){
                        let data = resp.data;
                        this.belongs = data.belong
                        this.finTypes = data.finType
                        this.payers = data.payer
                        this.items = data.sort
                        this.tags = data.tags
                        let start = this.calculateDate('start');
                        this.formModel.startDate = formatDate(start,'yyyy-MM-dd');
                        let end = this.calculateDate('end');
                        this.formModel.endDate = formatDate(end,'yyyy-MM-dd');

                    }else{
                        this.$toast.fail("数据初始化异常");
                    }

                }).catch((error) => {
                    console.log(error)
                    this.$toast.fail("数据初始化异常");
                })

            },


            openDatePicker(type){
                this.showDatePicker = true
                this.dateType = type
                this.pickDate = this.calculateDate(type)
            },
            calculateDate(type){
                if('start' == type){
                    let today = new Date();
                    let lastMonth = today - 1000*60*60*24*30;
                    return new Date(lastMonth);
                }else{
                    return new Date()
                }
            },
            onDateConfirm(value) {
                if('start' == this.dateType){
                    this.formModel.startDate = formatDate(value,'yyyy-MM-dd');
                }else{
                    this.formModel.endDate = formatDate(value,'yyyy-MM-dd');
                }
                this.showDatePicker = false;
            },

            selectTag(sortId, event, arr){
                debugger;
                let index = arr.indexOf(sortId);
                if(-1 == index){
                    arr.push(sortId)
                    event.target.classList.replace('van-tag--default','van-tag--danger')
                }else{
                    arr.splice(arr.findIndex(item => item === sortId), 1)
                    event.target.classList.replace('van-tag--danger','van-tag--default')
                }
            },
            submitForm(){
                this.$emit('qryData', this.formModel)

            }
        }
    }
</script>

<style scoped>

</style>
